import { PredefinedCustomerValues } from '../../types/customerForm/predefinedCustomerValues'

export const getCustomerFormDefaultValues = (predefinedCustomerValues?: PredefinedCustomerValues) => {
  return {
    address: {
      country: predefinedCustomerValues?.address?.country || '',
    },
    autoCompletedFields: undefined,
    eInvoiceAddress: {
      scheme: predefinedCustomerValues?.eInvoiceAddress?.scheme,
    },
    entityType: predefinedCustomerValues?.entityType,
    language: predefinedCustomerValues?.language,
    shippingAddress: {
      country: predefinedCustomerValues?.address?.country || '',
    },
  }
}
